import { math } from '@/lib/utils';
import Vue from 'vue';
export class CityDetailModel {
    public id: number| null = null;
    public name = '';
    /** 第几站 */
    public index = 0;
    public start_date = '';
    public end_date = '';
    /** pending=玩呢，success=玩完，failed=没玩好 */
    public status: Dream.CityStatus = 'pending';
    public distance = 0;
    public progress = 0;
    /** 已经完成的地标个数 */
    public finish_landmark_count = 0;
    /** 线路背景图 */
    public bg = '';
    /** 线路背景图宽 */
    public bg_width = 0;
    /** 线路背景图高 */
    public bg_height = 0;
    public tips = '';
    public landmarks: Array<Dream.CityLandmark<number>> = [];
    /** 是否前进过 */
    public is_go = false;
    /** 坐标对应rotate */
    public landmarkArrowMap: {[key: number]: number} = {};
    constructor(detail?: Dream.CityDetail) {
        if (detail) {
            const distance = 0;
            this.id = detail.id;
            this.name = detail.name;
            this.index = detail.index;
            this.start_date = detail.start_date;
            this.end_date = detail.end_date;
            this.status = detail.status;
            this.distance = detail.distance;
            this.progress = Number(detail.progress);
            this.finish_landmark_count = detail.finish_landmark_count;
            this.bg = detail.bg;
            this.bg_width = detail.bg_width;
            this.bg_height = detail.bg_height;
            this.tips = detail.tips;
            this.is_go = detail.is_go;
            this.landmarks = detail.landmarks.map((ele, idx) => {
                // distance += Number(ele.distance);
                const item = {
                    ...ele,
                    landmark_x: Number(ele.landmark_x),
                    landmark_y: Number(ele.landmark_y),
                    build_x: Number(ele.build_x),
                    build_y: Number(ele.build_y),
                    distance: Number(ele.distance),
                    // is_unlock: distance <= this.progress
                };
                const nextLandmark = detail.landmarks[idx + 1];
                const preLandmark = detail.landmarks[idx - 1];
                const x = item.landmark_x;
                const y = item.landmark_y;
                if (preLandmark) {
                    const x1 = Number(preLandmark.landmark_x);
                    const y1 = Number(preLandmark.landmark_y);
                    if (x > x1) {
                        Vue.set(this.landmarkArrowMap, item.id, 180);
                    } else {
                        Vue.set(this.landmarkArrowMap, item.id, 0);
                    }
                } else if (idx === 0 && nextLandmark) {
                    const x1 = Number(nextLandmark.landmark_x);
                    const y1 = Number(nextLandmark.landmark_y);
                    if (x < x1) {
                        Vue.set(this.landmarkArrowMap, item.id, 180);
                    } else {
                        Vue.set(this.landmarkArrowMap, item.id, 0);
                    }
                }
                return item;
            });
        }
    }
    public get landmarkIds() {
        return this.landmarks.map((ele) => ele.id);
    }
    /** 所有地表点 */
    public get landmarkAll() {
        return this.landmarks.filter((landmark) => landmark.type === 'landmark');
    }
    /** 地表数量 */
    public get landmarkCount() {
        return this.landmarkAll.length;
    }
    /** 所有拐点 */
    public get turnAll() {
        return this.landmarks.filter((landmark) => landmark.type === 'turn');
    }
}
